import $ from 'jquery';
import { dependency } from '../../utils/request';

const recaptchaPath = 'https://www.google.com/recaptcha/api.js';

/**
 * Enhances forms with Google reCAPTCHA functionality.
 * Requires use of the reCAPTCHA Craft plugin.
 *
 * @param context
 */
export default function validatorDirective(context=document.body) {
	const $context = $(context);
  const initialiseRecaptcha = () => {
		dependency(recaptchaPath, () => {
			$context.find('form.hs-form, form[sw-recaptcha]').each(function() {
				const $form = $(this);
				const $recaptcha = $form.find('.g-recaptcha');
				const callbackName = $form.attr('sw-recaptcha');
				const formParsley = window.Parsley ? $form.parsley() : null;
				window[callbackName] = () => {
					if (formParsley) {
            formParsley.whenValidate().then(() => $form.submit());
          } else {
            $form.submit();
          }
        }
			});
      return true;
		}, () => window.grecaptcha);
  }

  // If there are hubspot forms on the page provide a callback for the hubspot loader script to hook into
  const hsformsRendered = $context.find('form.hs-form').children().length > 0;
  if (!hsformsRendered) {
    window.loadRecaptcha = initialiseRecaptcha;
  } else { // otherwise just load as normal
    const $forms = $context.find('form[sw-recaptcha]');
    if ($forms.length > 0) initialiseRecaptcha();
  }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/recaptcha.js